var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material/styles';
import { switchClasses } from '@mui/material/Switch';
// ----------------------------------------------------------------------
export function switches(theme) {
    var lightMode = theme.palette.mode === 'light';
    var rootStyles = function (ownerState) {
        var _a, _b, _c, _d;
        return (__assign(__assign({ padding: '9px 13px 9px 12px', width: 58, height: 38 }, (ownerState.size === 'small' && {
            padding: '4px 8px 4px 7px',
            width: 40,
            height: 24
        })), (_a = {}, _a["& .".concat(switchClasses.thumb)] = __assign({ width: 14, height: 14, boxShadow: 'none', color: theme.palette.common.white }, (ownerState.size === 'small' && {
            width: 10,
            height: 10
        })), _a["& .".concat(switchClasses.track)] = {
            opacity: 1,
            borderRadius: 14,
            backgroundColor: alpha(theme.palette.grey[500], 0.48)
        }, _a["& .".concat(switchClasses.switchBase)] = __assign(__assign({ left: 3, padding: 12 }, (ownerState.size === 'small' && {
            padding: 7
        })), (_b = {}, _b["&.".concat(switchClasses.checked)] = __assign((_c = { transform: 'translateX(13px)' }, _c["&+.".concat(switchClasses.track)] = {
            opacity: 1
        }, _c), (ownerState.size === 'small' && {
            transform: 'translateX(9px)'
        })), _b["&.".concat(switchClasses.disabled)] = (_d = {},
            _d["& .".concat(switchClasses.thumb)] = {
                opacity: lightMode ? 1 : 0.48
            },
            _d["&+.".concat(switchClasses.track)] = {
                opacity: 0.48
            },
            _d), _b)), _a)));
    };
    return {
        MuiSwitch: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                }
            }
        }
    };
}
